module.exports = __webpack_public_path__ + "static/media/lineChart5.c23b090a.svg";